import { NGXLogger } from 'ngx-logger';
import { ConfigService } from 'ngx-envconfig';
import { HttpResponse, HttpHeaders, HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/internal/Observable';
import { Injectable } from '@angular/core';
import { Agentstorage } from 'src/app/models/agentstorage';
import { Fonction } from 'src/app/models/fonction';

@Injectable({
  providedIn: 'root'
})
export class FonctionService {

  authorization: string;

  private crudfonction = this.configService.get('ipMS') + 'parameter/fonction';

  constructor(private http: HttpClient, private configService: ConfigService,
    private logger: NGXLogger) {
    let user: Agentstorage = new Agentstorage();
    user = JSON.parse(localStorage.getItem('curentuser'));

    if (user != null) {
      this.authorization = user.token;
    }
  }



  getFonction(): Observable<HttpResponse<any>> {
    return this.http.get(this.crudfonction, {
      observe: 'response',
        headers: new HttpHeaders({ 'Access-Control-Allow-Origin': '*' })
          .set('content-Type', 'application/json')
          .set('Authorization', this.authorization)
      });
  }


  getFonctionGroupbytype(): Observable<HttpResponse<any>> {
    return this.http.get(this.crudfonction + '/' + 'groupbytype', {
      observe: 'response',
        headers: new HttpHeaders({ 'Access-Control-Allow-Origin': '*' })
          .set('content-Type', 'application/json')
          .set('Authorization', this.authorization)
      });
  }



  public createFonction(value: Fonction): Observable<HttpResponse<any>> {
    this.logger.trace("url : " + this.crudfonction);
    this.logger.trace(JSON.stringify(value));
    return this.http.post(this.crudfonction, JSON.stringify(value), {
      observe: 'response',
      headers: new HttpHeaders({ 'Access-Control-Allow-Origin': '*' })
        .set("content-Type", "application/json")
        .set("Authorization", this.authorization)
    });
  }



  public updateFonction(value: Fonction): Observable<HttpResponse<any>> {
    this.logger.trace("url : " + this.crudfonction);
    this.logger.trace(JSON.stringify(value));
    return this.http.put(this.crudfonction, JSON.stringify(value), {
      observe: 'response',
      headers: new HttpHeaders({ 'Access-Control-Allow-Origin': '*' })
        .set("content-Type", "application/json")
        .set("Authorization", this.authorization)
    });
  }



  deleteFonction(id: string): Observable<HttpResponse<any>> {
    return this.http.delete(this.crudfonction + '/' + id,
      {
        observe: 'response',
        headers: new HttpHeaders({ 'Access-Control-Allow-Origin': '*' })
          .set("content-Type", "application/json")
          .set("Authorization", this.authorization)
      });
  }

}
